module.exports = __webpack_public_path__ + "img/img_footer_mcst.bff6a3e2.png";